var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-container"},[_c('button',{staticClass:"copy-btn",on:{"click":_vm.copyCode}},[_vm._v(" "+_vm._s(_vm.copied ? '¡Copiado!' : 'Copiar')+" ")]),_c('pre',[_c('code',{ref:"codeBlock",class:'language-' + _vm.language},[_vm._v(_vm._s(_vm.code))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }